import React from 'react';
import { observer } from "mobx-react";
import moment from 'moment'

import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'

import LoadingGauge from './LoadingGauge'

import {goes16Store} from '../store/apiStores'


function createChartData(data, days, fireField) {
    let chartData = {
        loaded: false,
        name: 'Detections',
        dates: [],
        data: []
    };
    if (data) {
        // create series data
        data.forEach(function(v){
            let datetimeStr = v.date_local.slice(0, 11)
            chartData['data'].push(v[fireField])
            chartData['dates'].push(datetimeStr)
        });
        chartData.data.splice(0, (chartData.data.length - days));
        chartData.dates.splice(0, (chartData.dates.length - days));
        chartData.loaded = true
    }
    return chartData;
}

export default observer(function StateFiresGauge(props) {
    let chartData = {data: []};
    let title = `${props.state} State GOES-16 fire detections`
    let days = 10
    let labels = true
    let dim = null
    if (props.gauge){
        labels = false
        dim = 100
        days = 5
        title = ""
    };
    if (props.state || props.gauge) {
        chartData = createChartData(goes16Store.data, days, 'total_goes_16');
    } else if (props.county){
        title = `${props.county} County GOES-16 fire detections`
        chartData = createChartData(goes16Store.data, days, 'goes16_count');
    }

    let options = {
		chart: {
			type: 'column',
			height: dim,
			width: dim
		},

		credits: {
			enabled: labels
		},

	    title: {
	        text: title
	    },

	    legend: {
	        enabled: false
	    },

	    yAxis: {
			min: 0,
			endOnTick: false,
			title: {
				text: ''
			},
			labels: {
				enabled: labels
			}
		},

	    xAxis: {
			categories: chartData.dates,
			labels: {
				enabled: labels
			},
			title: {
				text: ''
			}
		},

		tooltip: {
			enabled: labels
		},

	    plotOptions: {
	        series: {
	            marker: {
	                states: {
	                    hover: {
	                        enabled: false
	                    }
	                }
	            }
	        }
		},

	    series: [chartData]

    }

    if (!chartData.loaded) {
        return (
            <LoadingGauge />
        )
    } else if (chartData.data.length > 0) {
        return (
            <HighchartsReact
                highcharts={Highcharts}
                options={options} />
        )
    } else {
		return null
    }
})
